import { render, staticRenderFns } from "./shortcut_button.vue?vue&type=template&id=e0c7d164&scoped=true"
import script from "./shortcut_button.vue?vue&type=script&lang=js"
export * from "./shortcut_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c7d164",
  null
  
)

export default component.exports